import React, {useEffect, useState} from 'react';

import ReactModal from 'react-modal';
import moment from "moment";
import {DayPickerRangeController} from 'react-dates';
import {timeOptions} from "../../../helpers/data-constants";
import {END_DATE} from 'react-dates/constants';

import {CommonButton} from "./CommonButton/CommonButton";

import CrossIcon from '../../../assets/icons/cross.svg';
import CalendarIcon from '../../../assets/icons/calendar.svg';

import 'react-dates/initialize';

import 'react-dates/lib/css/_datepicker.css';
import '../../../assets/styles/components/_modal.scss';
import './daterange-picker.scss';

const AppDatePicker = ({startDate, endDate, onChange, coverClass, error, inputClass, period = timeOptions}) => {
    const [state, setState] = useState({
        showModalDateRangePicker: false,
        errorMessage: null,
        startDate: startDate,
        endDate: endDate,
        focusedInput: END_DATE,
    });
    const inputDefaultClass = 'input-small';

    useEffect(() => {
        if (startDate !== state.startDate || endDate !== state.endDate) {
            setState((prev) => ({...prev, startDate: startDate, endDate: endDate}));
        }
    }, [startDate, endDate]);

    const handleOpenModalDateRangePicker = (e) => {
        e.preventDefault();
        setState((prev) => ({...prev, showModalDateRangePicker: true}));
    };

    const handleCancel = () => {
        setState((prev) => ({
            ...prev,
            startDate: startDate,
            endDate: endDate,
        }))
        handleCloseModalDateRangePicker()
    }

    const handleCloseModalDateRangePicker = () => {
        setState((prev) => ({
            ...prev,
            startDate: startDate,
            endDate: endDate,
            showModalDateRangePicker: false
        }))
    };

    const handleDatesChange = ({startDate, endDate}) => {
        setState((prev) => ({...prev, startDate, endDate}));
    };

    const handleFocusChange = (focusedInput) => {
        setState((prev) => ({...prev, focusedInput: !focusedInput ? END_DATE : focusedInput}));
    };

    const handleReset = () => {
        setState((prev) => ({
            ...prev,
            startDate: null,
            endDate: null,
        }))
    };

    const handleSave = () => {
        onChange && onChange({startDate: state.startDate, endDate: state.endDate});

        handleCloseModalDateRangePicker();
    };

    const formatDate = (v) => {
        return v ? v.format('DD-MM-yyyy') : '';
    };

    const handleSetTimeRange = (start, end) => {
        setState((state) => ({
            ...state,
            startDate: moment(start),
            endDate: moment(end),
        }))
    }

    return (
        <div className={coverClass}>
            <div className={error ? 'form-element-data daterange invalid' : 'form-element-data daterange'}>
                <div className="daterange-form">
                    <span>с</span>
                    <input
                        disabled={true}
                        className={inputClass || inputDefaultClass}
                        type="text"
                        pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d"
                        value={state.startDate >= 0 ? formatDate(state.startDate) : ''}
                    />
                    <span>по</span>
                    <input
                        disabled={true}
                        className={inputClass || inputDefaultClass}
                        type="text"
                        pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d"
                        value={state.endDate >= 0 ? formatDate(state.endDate) : ''}
                    />
                </div>
                <div className="daterange-action">
                    <button className="button-icontrigger noborder" onClick={handleOpenModalDateRangePicker}>
                        <span className="icon"><CalendarIcon/></span>
                    </button>
                    <ReactModal
                        isOpen={state.showModalDateRangePicker}
                        contentLabel="Modal"
                        className="modal-container"
                        overlayClassName="modal-overlay">
                        <div className="modal-header">
                            <h2>Выберите дату </h2>
                            <button
                                className="button-icontrigger modal-closetrigger"
                                onClick={handleCloseModalDateRangePicker}>
                                <span className="icon"><CrossIcon/></span>
                            </button>
                        </div>
                        <div className="modal-footer">
                            {period.map(({start, end, key, displayName}) =>
                                <CommonButton key={key}
                                              startValue={start}
                                              endValue={end}
                                              displayName={displayName}
                                              handleSetTimeRange={handleSetTimeRange}
                                              handleReset={handleReset}
                                              handleSave={handleSave}
                                />
                            )}
                        </div>
                        <div className="modal-body">
                            <DayPickerRangeController
                                startDate={state.startDate}
                                endDate={state.endDate}
                                onDatesChange={handleDatesChange}
                                onFocusChange={handleFocusChange}
                                focusedInput={state.focusedInput}
                                initialVisibleMonth={() => state.endDate ? moment(state.endDate).subtract(1, "month") : moment().subtract(1, "month")}
                                numberOfMonths={2}
                                minimumNights={0}
                                hideKeyboardShortcutsPanel={true}
                                noBorder={true}
                            />
                        </div>
                        <div className="modal-footer">
                            <button className="button" type="button" onClick={handleSave}>
                                Применить
                            </button>
                            <button
                                className="button-light"
                                type="button"
                                onClick={handleCancel}>
                                Отмена
                            </button>
                            <button className="button-icontrigger datePicker-clearBtn noborder" onClick={handleReset}>
                                Очистить
                            </button>
                        </div>
                    </ReactModal>
                </div>
            </div>
            <span className={'form-message error'}>{error}</span>
        </div>
    );
};

export default AppDatePicker;
